import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Feedback from "./feedback";
import { getFeedback } from "services/redux/brandActivtion/meetings/action";

import {
  getSiteFilters,
} from 'services/redux/brandActivtion/sitesListing/action';

const mapStateToProps = (state) => ({
  meetingList: state.baMeetingReducer.feedbackList,
  siteFilters: state.baSiteListingReducer.siteFiltersData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFeedback,
      getSiteFilters,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
